import { ResponseReuseType } from '../constants';
import { routeMappings } from '../../constants';
import { ResponseReuseInfo } from '../interfaces';

export const redirectUrlOnPartialResponseReuse = ({ type }: ResponseReuseInfo): string => {
  if (type === ResponseReuseType.PARTIAL_RR) {
    const launchAssessmentConfig = sessionStorage.getItem('launchconfig');
    const parsedLaunchAssessmentConfig = launchAssessmentConfig && JSON.parse(launchAssessmentConfig);

    // Launch Assessment
    if (parsedLaunchAssessmentConfig) {
      return `${routeMappings['TASK']}/${parsedLaunchAssessmentConfig.taskId}${routeMappings['EXPASSES']}/${parsedLaunchAssessmentConfig.itemId}`;
    }
  }
  return '';
};
